export const FETCH_CUSTOMERS_DATA = "FETCH_CUSTOMERS_DATA";
export const FETCH_CUSTOMERS_SUCCESS = "FETCH_CUSTOMERS_SUCCESS";
export const FETCH_CUSTOMERS_FAILURE = "FETCH_CUSTOMERS_FAILURE";